<template>
  <div v-if="parentPortalOptions != null">
    <v-list>
      <v-list-item :disabled="isReadonly" @click="dialog = true">
        <v-list-item-title>Basic</v-list-item-title>
        <v-list-item-subtitle>
          <v-progress-circular
            v-if="currentBasicProfile == null"
            indeterminate
          ></v-progress-circular>
          <div v-else-if="currentBasicProfile != null">
            {{ currentBasicProfile.label }}
          </div>
          <div v-else>-</div>
        </v-list-item-subtitle>
      </v-list-item>
      <v-list-item :disabled="isReadonly" @click="dialog = true">
        <v-list-item-title>Full</v-list-item-title>
        <v-list-item-subtitle>
          <v-progress-circular
            v-if="currentFullProfile == null"
            indeterminate
          ></v-progress-circular>
          <div v-else-if="currentFullProfile != null">
            {{ currentFullProfile.label }}
          </div>
          <div v-else>-</div>
        </v-list-item-subtitle>
      </v-list-item>
      <v-list-item :disabled="isReadonly" @click="dialog = true">
        <v-list-item-title>Carte gratuite</v-list-item-title>
        <v-list-item-subtitle>
          <v-progress-circular
            v-if="currentFreeCardModel == null"
            indeterminate
          ></v-progress-circular>
          <div v-else-if="currentFreeCardModel != null">
            {{ currentFreeCardModel.description }}
          </div>
          <div v-else>-</div>
        </v-list-item-subtitle>
      </v-list-item>
      <v-list-item :disabled="isReadonly" @click="dialog = true">
        <v-list-item-title>TVA</v-list-item-title>
        <v-list-item-subtitle>
          {{ parentPortalOptions.vat }}%
        </v-list-item-subtitle>
      </v-list-item>
    </v-list>
    <edit-portal-options-dialog
      v-if="!isReadonly && dialog == true"
      :open.sync="dialog"
      :portal-options.sync="parentPortalOptions"
      :profiles="profiles"
      :card-models="cardModels"
    ></edit-portal-options-dialog>
  </div>
</template>
<script>
import { toRefs, computed, onMounted } from "@vue/composition-api";
import { usePortalOptions } from "../../composables/portal-options";
import { useCardModel } from "../../composables/card-model";
import { useProfile } from "../../composables/profile";
import EditPortalOptionsDialog from "@/components/PortalOptions/EditPortalOptionsDialog";

export default {
  components: { EditPortalOptionsDialog },
  props: {
    portalOptions: Object,
    partner: Object,
    isReadonly: {
      default: false,
      type: Boolean,
    },
  },

  setup(props, { emit }) {
    /* Import des API */
    const { updatePortalOptions, portalOptionData } = usePortalOptions();
    const { cardModels, listCardModels } = useCardModel();
    const { profiles, listProfiles } = useProfile();

    /* Computed */
    const parentPortalOptions = computed({
      get: () => props.portalOptions,
      set: (value) => {
        emit("update:portalOptions", value);
      },
    });
    const currentBasicProfile = computed(() => {
      return profiles.value.find(
        (element) => element.id == parentPortalOptions.value.basicProfile
      );
    });

    const currentFullProfile = computed(() => {
      return profiles.value.find(
        (element) => element.id == parentPortalOptions.value.fullProfile
      );
    });

    const currentFreeCardModel = computed(() => {
      return cardModels.value.find(
        (element) => element.id == parentPortalOptions.value.freeCardModel
      );
    });

    /* Méthodes */
    const updateOptions = function () {
      const formData = {
        name: parentPortalOptions.value.name,
        vat: parentPortalOptions.value.vat,
        basicProfile: parentPortalOptions.value.basicProfile,
        fullProfile: parentPortalOptions.value.fullProfile,
        freeCardModel: parentPortalOptions.value.freeCardModel,
        activateSsl: parentPortalOptions.value.activateSsl,
      };
      Object.assign(portalOptionData.portalOptionsForm, formData);
      updatePortalOptions(parentPortalOptions.value);
    };

    /* Cycle de vie */
    onMounted(async () => {
      const freeCardOrigin = 3;
      await listCardModels(props.partner.id, freeCardOrigin);
      await listProfiles(props.partner.id);
    });

    return {
      parentPortalOptions,
      cardModels,
      profiles,
      ...toRefs(portalOptionData),
      currentBasicProfile,
      currentFullProfile,
      currentFreeCardModel,
      updateOptions,
    };
  },
};
</script>
